module.exports = __webpack_public_path__ + "img/content-1.74a94cd6.png";